var _mask, _path, _g, _rect, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 210,
    viewBox: "0 0 118 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_554_78",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3105 210L58.3105 210L58.3106 108L60.3106 108L60.3105 210Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3105 210L61.3105 206.94L59.3105 206.94L59.3105 210L61.3105 210ZM61.3105 202.86L61.3105 196.74L59.3105 196.74L59.3105 202.86L61.3105 202.86ZM61.3105 192.66L61.3105 186.54L59.3105 186.54L59.3105 192.66L61.3105 192.66ZM61.3105 182.46L61.3105 176.34L59.3105 176.34L59.3105 182.46L61.3105 182.46ZM61.3106 172.26L61.3106 166.14L59.3106 166.14L59.3106 172.26L61.3106 172.26ZM61.3106 162.06L61.3106 155.94L59.3106 155.94L59.3106 162.06L61.3106 162.06ZM61.3106 151.86L61.3106 145.74L59.3106 145.74L59.3106 151.86L61.3106 151.86ZM61.3106 141.66L61.3106 135.54L59.3106 135.54L59.3106 141.66L61.3106 141.66ZM61.3106 131.46L61.3106 125.34L59.3106 125.34L59.3106 131.46L61.3106 131.46ZM61.3106 121.26L61.3106 115.14L59.3106 115.14L59.3106 121.26L61.3106 121.26ZM61.3106 111.06L61.3106 108L59.3106 108L59.3106 111.06L61.3106 111.06ZM62.3105 210L62.3105 206.94L58.3105 206.94L58.3105 210L62.3105 210ZM62.3105 202.86L62.3105 196.74L58.3105 196.74L58.3105 202.86L62.3105 202.86ZM62.3105 192.66L62.3105 186.54L58.3105 186.54L58.3105 192.66L62.3105 192.66ZM62.3105 182.46L62.3105 176.34L58.3105 176.34L58.3105 182.46L62.3105 182.46ZM62.3106 172.26L62.3106 166.14L58.3106 166.14L58.3106 172.26L62.3106 172.26ZM62.3106 162.06L62.3106 155.94L58.3106 155.94L58.3106 162.06L62.3106 162.06ZM62.3106 151.86L62.3106 145.74L58.3106 145.74L58.3106 151.86L62.3106 151.86ZM62.3106 141.66L62.3106 135.54L58.3106 135.54L58.3106 141.66L62.3106 141.66ZM62.3106 131.46L62.3106 125.34L58.3106 125.34L58.3106 131.46L62.3106 131.46ZM62.3106 121.26L62.3106 115.14L58.3106 115.14L58.3106 121.26L62.3106 121.26ZM62.3106 111.06L62.3106 108L58.3106 108L58.3106 111.06L62.3106 111.06Z",
    fill: "#777777",
    mask: "url(#path-1-inside-1_554_78)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_554_78)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.31055,
    y: 4,
    width: 105,
    height: 105,
    rx: 52.5,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.3105,
    y: 210,
    width: 22,
    height: 22,
    rx: 11,
    transform: "rotate(-180 70.3105 210)",
    fill: "#008FAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7139 37C49.3535 36.9995 49.0077 37.1419 48.752 37.3959C48.4964 37.6499 48.3518 37.9949 48.35 38.3552V43.594H37.8456C37.5107 43.6273 37.2001 43.7841 36.9743 44.0338C36.7485 44.2835 36.6237 44.6082 36.624 44.9449V52.7743C36.624 55.6097 38.8087 57.8838 41.8671 59.5244C44.6045 60.9873 48.4029 61.867 52.4964 62.405V58.4451C52.4959 58.0847 52.6383 57.7389 52.8923 57.4832C53.1463 57.2276 53.4912 57.083 53.8516 57.0812H62.8671C63.2275 57.083 63.5724 57.2276 63.8264 57.4832C64.0805 57.7389 64.2228 58.0847 64.2224 58.4451V62.4041C68.3149 61.8783 72.123 60.9951 74.8603 59.5236C77.9187 57.8916 80.0947 55.6193 80.0947 52.7734V44.9449C80.0922 44.5865 79.9483 44.2435 79.6944 43.9906C79.4405 43.7376 79.097 43.5951 78.7386 43.594H68.3601V38.3552C68.3602 38.1772 68.3252 38.0008 68.257 37.8363C68.1889 37.6717 68.089 37.5223 67.9631 37.3964C67.8371 37.2705 67.6876 37.1707 67.523 37.1027C67.3584 37.0347 67.182 36.9998 67.004 37H49.7139ZM51.0691 39.72H65.6401V43.594H51.07L51.0691 39.72ZM55.2068 59.7925V63.3238H61.4937V59.7925H55.2068ZM78.6857 60.2654C77.885 60.8876 77.0318 61.4392 76.1357 61.9139C73.2333 63.3102 70.1266 64.2343 66.9328 64.6512V64.6599C59.8434 65.6941 56.1742 65.721 49.7764 64.6599V64.6512C46.5848 64.2334 43.4802 63.3094 40.5795 61.9139C39.6867 61.4366 38.834 60.8879 38.0296 60.2732V74.9951C38.0291 75.3555 38.1715 75.7013 38.4255 75.957C38.6795 76.2126 39.0244 76.3572 39.3848 76.359H77.3304C77.6908 76.3572 78.0358 76.2126 78.2898 75.957C78.5438 75.7013 78.6861 75.3555 78.6857 74.9951V60.2654Z",
    fill: "url(#paint0_linear_554_78)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_554_78",
    x: 0.310547,
    y: 0,
    width: 117,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_554_78"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_554_78",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_78",
    x1: 48.7523,
    y1: 37,
    x2: 75.736,
    y2: 86.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/Experience.4d85f50744ceca0a4489dc7f680557a1.svg";
export { ForwardRef as ReactComponent };